<div class="tmp-section-item-wrapper">
    <span class="tmp-section-title">{{title}}</span>
    <ng-container *ngIf="!isCheckBox else modecheckbox">
        <div class="tmp-section-body tmp-flexy">
            <ng-container *ngFor="let item of list">
                <button class="tmp-f-btn" [class.tmp-f-btn-selected]="item.selected" [matTooltip]="item?.description" (click)="selectItem(item)"
                    matRipple>{{item.name}}</button>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #modecheckbox>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of sortArray(list)| slice:0:slicenbr">
            <button class="tour-item-wrapper" (click)="selectItem(item)" [matTooltip]="item?.description" matRipple>
                <mat-icon class="tour-item-icon ">{{item.selected ? 'check_box' : 'check_box_outline_blank'}}</mat-icon>
                <span class="tour-item-name">{{item.name}}</span>
            </button>
        </ng-container>
        <ng-container *ngIf="list?.length > 5">
            <ng-container *ngIf="(slicenbr < list.length) else less">
                <button class="showallbtn" (click)="showMore(list.length)" matRipple>
                    <span>alle {{list.length}} anzeigen</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span>weniger anzeigen</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>